/**
 * 该文件存放交换记录相关页面路由
 */

const exchangeRecordRoutes = [
  {
    path: '/',
    component: () => import('@/homepage'),
    children: [
      // 交换记录的收件箱
      {
        path: '/records-inbox',
        name: 'RecordsInbox',
        meta: {
          menuName: 'record-receive'
        },
        component: () => import('@/pages/records/inbox')
      },
      // 交换记录的发件箱
      {
        path: '/records-outbox',
        name: 'RecordsOutbox',
        meta: {
          menuName: 'record-send'
        },
        component: () => import('@/pages/records/outbox')
      },
    ]
  }
];

export default exchangeRecordRoutes;
